import React from 'react';
import { Label, Field, ErrorMessage } from '../FormikCustom';

const InputText = React.forwardRef(
    ({ name, label, forceError, showInfoIcon, iconType, infoTitleText, required, ...rest }, ref) => {
        let infoClass = `help-tooltip ${iconType}`;
        let infoIcon = showInfoIcon ? <i className={infoClass} data-tip={infoTitleText} data-place="right"></i> : null;

        let className = 'form-control';
        if (forceError) className += ' error';

        return (
            <div className="form-group" >
                {label ? (
                    <Label required={required} htmlFor={name}>
                        {label}
                    </Label>
                ) : null}
                {infoIcon}
                <Field ref={ref} type="text" name={name} className={className} {...rest} />

                <ErrorMessage name={name} />
            </div>
        );
    }
);
InputText.displayName = 'InputText'; // Add display name for the component

export default InputText;
